import { validateTidalLicense } from "../base/index.js";
validateTidalLicense();
export * from "@workwave-tidal/foundation/framer-motion";
//# sourceMappingURL=index.js.map
